<template>
<!-- <span :key="id" > -->
  <span :key="id" v-if="done" v-html="translation" />
    <!-- {{ translation }}  -->
  <!-- </span>  -->
  <span class="phrase-mounting" :key="id" ref="phrase" v-else>
    <slot/> 
  </span>
<!-- </span> -->
</template>

<script>
export default {
  data: () => ({
    done: false,
    phrase: ''
  }),
  computed: {
    id(){
      return Math.random() * 999999999999999
    },
    translation() {
      return `${this.$t(this.phrase)} `
    }
  },
  mounted(){
    this.$nextTick(() => {
      this.phrase = this.$refs.phrase?.innerHTML
      this.done = true
    })
  }
}
</script>

<style>
.phrase-original {
  display: none;
}

.phrase-mounting {
  color: var(--v-secondary-base) !important;
  background-color: var(--v-secondary-base) !important;
  border-radius: 4px;
}
</style>